import { CanActivateFn, CanMatchFn, Router, Routes } from '@angular/router'
import { AuthTemplateComponent } from './components/hrmsLayout/template/auth-template/auth-template.component'
import { LoginComponent } from './components/hrmsLayout/auth/login/login.component'
import { DashboardComponent } from './components/hrmsLayout/dashboard/dashboard.component'
import { eps } from './services/url.service' //endPoints
import { authGuard } from './guards/auth.guard'
import { GuestGuard } from './guards/guest.guard'
// import { permissionGuard } from './guards/permissionNOld.guard'
import { permissionGuard } from './guards/permission.guard'
import { UnauthorizedComponent } from './components/hrmsLayout/unauthorized/unauthorized.component'
import { AppTemplateComponent } from './components/hrmsLayout/template/app-template/app-template.component'
import { BusinessComponent } from './components/hrmsLayout/business/business.component'
import { WrapperComponent } from './components/hrmsLayout/salary-components/wrapper/wrapper.component'
import { BusinessDetailComponent } from './components/hrmsLayout/business/business-detail/business-detail.component'
import { RegistrationComponent } from './components/hrmsLayout/auth/registration/registration.component'
import { ForgotPasswordComponent } from './components/hrmsLayout/auth/forgot-password/forgot-password.component'
import { ResetPasswordComponent } from './components/hrmsLayout/auth/reset-password/reset-password.component'
import { DepartmentComponent } from './components/hrmsLayout/department/department.component'
import { DesignationComponent } from './components/hrmsLayout/designation/designation.component'
import { EmployeeComponent } from './components/hrmsLayout/employee/employee.component'
import { EmployeeDetailComponent } from './components/hrmsLayout/employee/employee-detail/employee-detail.component'
import { RolePermissionComponent } from './components/hrmsLayout/role-permission/role-permission.component'
import { EmployeeSalaryWrapperComponent } from './components/hrmsLayout/employee-salary/employee-salary-wrapper/employee-salary-wrapper.component'
import { HolidaysComponent } from './components/hrmsLayout/leaves/holidays/holidays.component'
import { LeavePoliciesComponent } from './components/hrmsLayout/leaves/leave-policies/leave-policies.component'
import { AppliedLeavesComponent } from './components/hrmsLayout/leaves/applied-leaves/applied-leaves.component'
import { LeavesRequestComponent } from './components/hrmsLayout/leaves/leaves-request/leaves-request.component'
import { AttendanceComponent } from './components/hrmsLayout/employee/attendance/attendance.component'
import { CalanderComponent } from './components/hrmsLayout/attendance/calander/calander.component'
import { AttendancePolicyComponent } from './components/hrmsLayout/attendance/attendance-policy/attendance-policy.component'
import { OfficeDetailsComponent } from './components/hrmsLayout/office/office-details/office-details.component'
import { AttendanceListComponent } from './components/hrmsLayout/attendance/attendance-list/attendance-list.component'
import { EmpDashboardComponent } from './components/hrmsLayout/employee/dashboard/dashboard.component'
import { SalaryMode } from './store/employee-salary/employee-salary.state'
import { PermissionSetsComponent } from './components/hrmsLayout/permission-sets/permission-sets.component'
import { PermissionSetDetailsComponent } from './components/hrmsLayout/permission-sets/details/details.component'
import { ManagePayrollComponent } from './components/hrmsLayout/payroll/manage-payroll/manage-payroll.component'
import { RunPayrollComponent } from './components/hrmsLayout/payroll/run-payroll/run-payroll.component'
import { PayslipWrapperComponent } from './components/hrmsLayout/payroll/payslip-wrapper/payslip-wrapper.component'
import { EmployeeRequestComponent } from './components/hrmsLayout/employee-request/employee-request.component'
import { OrgChartComponent } from './components/hrmsLayout/org-chart/org-chart.component'
import { LeavePolicyDetailComponent } from './components/hrmsLayout/leaves/leave-policies/leave-policy-detail/leave-policy-detail.component'
import { PayrollSummaryComponent } from './components/hrmsLayout/payroll/payroll-summary/payroll-summary.component'
import { InvestmentsWrapperComponent } from './components/hrmsLayout/investments/wrapper/investments-wrapper.component'
import { LeaveBalanceComponent } from './components/hrmsLayout/leaves/leave-balance/leave-balance.component'
import { TaxWrapperComponent } from './components/hrmsLayout/tax/tax-wrapper/tax-wrapper.component'
import { PlansComponent } from './components/hrmsLayout/plans/plans.component'
import { BasicComponent } from './components/hrmsLayout/planAndBilling/basic/basic.component'
import { SubscribersComponent } from './components/hrmsLayout/subscribers/subscribers.component'
import { LicenceHistoryComponent } from './components/hrmsLayout/planAndBilling/licence-history/licence-history.component'
import { PayoutAgreementWrapperComponent } from './components/hrmsLayout/payoutAgreement/payout-agreement-wrapper/payout-agreement-wrapper.component'
import { PayOutMode } from './store/payout-agreement/payout-agreement.state'
import { ManageContractorPayrollComponent } from './components/hrmsLayout/contractor-payroll/manage-contractor-payroll/manage-contractor-payroll.component'
import { RunContractorPayrollComponent } from './components/hrmsLayout/contractor-payroll/run-contractor-payroll/run-contractor-payroll.component'
import { RoleComponent } from './components/hrmsLayout/role/role.component'
import { RoleDetailComponent } from './components/hrmsLayout/role/roleDetail/role-detail.component'
import { PermissionSetComponent } from './components/hrmsLayout/permission-set/permission-set.component'
import { PermissionSetDetailComponent } from './components/hrmsLayout/permission-set/permissionSetDetail/permission-set-detail.component'
import { ContractorPayrollSummaryComponent } from './components/hrmsLayout/contractor-payroll/payroll-summary/contractor-payroll-summary.component'
import { InvoiceWrapperComponent } from './components/hrmsLayout/contractor-payroll/invoice-wrapper/invoice-wrapper.component'
import { PlanSelectionComponent } from './components/hrmsLayout/planAndBilling/plan-selection/plan-selection.component'
import { PlanChangeSummaryComponent } from './components/hrmsLayout/planAndBilling/plan-change-summary/plan-change-summary.component'
import { PaymentCallbackComponent } from './components/hrmsLayout/planAndBilling/payment-callback/payment-callback.component'
import { PaymentSuccessComponent } from './components/hrmsLayout/planAndBilling/payment-success/payment-success.component'
import { PaymentFailureComponent } from './components/hrmsLayout/planAndBilling/payment-failure/payment-failure.component'
import { ActivatePlanComponent } from './components/hrmsLayout/planAndBilling/activate-plan/activate-plan.component'
import { AddLicencePreviewComponent } from './components/hrmsLayout/planAndBilling/add-licence-preview/add-licence-preview.component'
import { BirthdaysComponent } from './components/hrmsLayout/birthdays/birthdays.component'
import { AnniversaryComponent } from './components/hrmsLayout/anniversary/anniversary.component'
import { NotificationComponent } from './notification/notification.component'
import { TeamMembersComponent } from './components/hrmsLayout/team-members/team-members.component'
import { AttendancePolicyDetailsComponent } from './components/hrmsLayout/attendance/attendance-policy/attendance-policy-details/attendance-policy-details.component'
import { OwnerDashboardComponent } from './components/hrmsLayout/business/owner-dashboard/owner-dashboard.component'
import { ChooseSubscriptionComponent } from './components/hrmsLayout/auth/choose-subscription/choose-subscription.component'
// import { PublicLayoutComponent } from './layouts/public-layout/public-layout.component'
import { HomeComponent } from './pages/home/home.component'
import { HrmsLayoutComponent } from './components/hrmsLayout/hrmsLayout.component'
import { WebsiteLayoutComponent } from './components/websiteLayout/website-layout.component'
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component'
import { RefundPolicyComponent } from './pages/refund-policy/refund-policy.component'
import { TermsConditionComponent } from './pages/terms-condition/terms-condition.component'
import { environment } from '../environments/environment'
import { CouponComponent } from './components/hrmsLayout/coupon/coupon.component'
import { isHrmsHost } from './utils/host-detection'
import { BillingComponent } from './components/hrmsLayout/planAndBilling/billing/billing.component'
import { UtilsService } from './services/utils.service'
import { inject } from '@angular/core'
import { CronComponent } from './components/hrmsLayout/cron/cron.component'
import { CronDetailComponent } from './components/hrmsLayout/cron/cronDetail/cron-detail.component'
import { NotificationCampaignComponent } from './components/hrmsLayout/notificationCampaign/notification-campaign.component'
import { NotificationCampaignDetailComponent } from './components/hrmsLayout/notificationCampaign/notificationCampaignDetail/notification-campaign-detail.component'
import { NotificationOccasionTemplateComponent } from './components/hrmsLayout/notificationCampaign/notificationCampaignOccasionTemplate/notification-campaign-occasion-template.component'
import { EarningsComponent } from './components/hrmsLayout/earnings/earnings.component'
import { UserLoginHistoryComponent } from './components/hrmsLayout/loginHistory/login-history.component'

// eslint-disable-next-line no-console
console.log('app.routes urls', eps)

//19nov 2025
// export const routes: Routes = [
//   // AUTH routes (separate layout)
//   // {
//   //   path: '',
//   //   component: PublicLayoutComponent,
//   //   children: [
//   //     { path: '', component: HomeComponent }
//   //     //   { path: 'about', component: AboutComponent },
//   //     //   { path: 'pricing', component: PricingComponent },
//   //     //   { path: 'features', component: FeaturesComponent },
//   //     //   { path: 'contact', component: ContactComponent }
//   //   ]
//   // },
//   {
//     path: '',
//     component: WebsiteLayoutComponent,
//     pathMatch: 'full',
//     children: [
//       { path: '', component: HomeComponent },
//       { path: 'privacy-policy', component: PrivacyPolicyComponent },
//       { path: 'refund-policy', component: RefundPolicyComponent },
//       { path: 'terms-and-conditions', component: TermsConditionComponent }
//       //   { path: 'about', component: AboutComponent },
//       //   { path: 'pricing', component: PricingComponent },
//       //   { path: 'features', component: FeaturesComponent },
//       //   { path: 'contact', component: ContactComponent }
//     ]
//   },
//   {
//     path: 'app',
//     component: HrmsLayoutComponent,
//     children: [
//       {
//         path: eps.auth.base,
//         component: AuthTemplateComponent,
//         children: [
//           { path: eps.auth.login, component: LoginComponent },
//           { path: `${eps.auth.register}/:id`, component: RegistrationComponent },
//           { path: `${eps.auth.chooseSubscription}/:id`, component: ChooseSubscriptionComponent },
//           { path: eps.auth.forgotPassword, component: ForgotPasswordComponent },
//           { path: eps.auth.resetPassword, component: ResetPasswordComponent },
//           // default of auth base -> login
//           { path: '', redirectTo: eps.auth.login, pathMatch: 'full' }
//         ]
//       },
//       {
//         path: '',
//         component: AppTemplateComponent,
//         canActivate: [authGuard],
//         children: [
//           // USER module routes (kept as same final URLs as before)
//           {
//             path: `${eps.user.base}/${eps.user.dashboard}`,
//             component: DashboardComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { dashboard: ['view', 'edit'] } }
//           },
//           { path: `${eps.user.base}/${eps.user.unauthorized}`, component: UnauthorizedComponent },
//           {
//             path: `${eps.user.base}/${eps.user.employeeDashboard}`,
//             component: EmpDashboardComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { dashboard: ['view', 'edit'] } }
//           },
//           {
//             path: `${eps.user.base}/${eps.user.ownerDashboard}`,
//             component: OwnerDashboardComponent
//             // canActivate: [permissionGuard],
//             // data: { permissions: { dashboard: ['view', 'edit'] } }
//           },
//           {
//             path: `${eps.user.base}/${eps.user.employeeRequest}`,
//             component: EmployeeRequestComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: [{ user: ['view'] }, { employees: ['view'] }] }
//           },
//           {
//             path: `${eps.user.base}/${eps.user.orgChart}`,
//             component: OrgChartComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: [{ user: ['view'] }, { employees: ['view'] }] }
//           },

//           // COMPANY module
//           {
//             path: `${eps.company.base}/${eps.company.business}`,
//             component: BusinessComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { business: ['view'] } }
//           },
//           {
//             path: `${eps.company.base}/${eps.company.business}/:id`,
//             component: BusinessDetailComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { business: ['view'] } }
//           },
//           {
//             path: `${eps.company.base}/${eps.company.salaryComponents}`,
//             component: WrapperComponent
//           },
//           {
//             path: `${eps.company.base}/${eps.company.office}/:id`,
//             component: OfficeDetailsComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { office: ['view'] } }
//           },
//           {
//             path: `${eps.company.base}/${eps.company.department}`,
//             component: DepartmentComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { department: ['view'] } }
//           },
//           {
//             path: `${eps.company.base}/${eps.company.designation}`,
//             component: DesignationComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { designation: ['view'] } }
//           },
//           {
//             path: `${eps.company.base}/${eps.company.taxSettings}`,
//             component: TaxWrapperComponent
//           },

//           // SUPER ADMIN
//           {
//             path: `${eps.superAdmin.base}/${eps.superAdmin.plans}`,
//             component: PlansComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { plans: ['view'] } }
//           },
//           {
//             path: `${eps.superAdmin.base}/${eps.superAdmin.subscribers}`,
//             component: SubscribersComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { plans: ['view'] } }
//           },
//           {
//             path: `${eps.superAdmin.base}/${eps.superAdmin.licenceHistory}/:id`,
//             component: LicenceHistoryComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { plans: ['view'] } }
//           },

//           // HRM
//           {
//             path: `${eps.hrm.base}/${eps.hrm.employee}`,
//             component: EmployeeComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: [{ user: ['view'], employees: ['view'] }] }
//           },
//           {
//             path: `${eps.hrm.base}/${eps.hrm.employee}/:id`,
//             component: EmployeeDetailComponent,
//             canActivate: [permissionGuard],
//             // data: { permissions: { user: ['view'], employees: ['view'] } }
//             data: { permissions: [{ user: ['view'] }, { employees: ['view'] }] }
//           },

//           {
//             path: `${eps.hrm.base}/${eps.hrm.createSalary}/:id`,
//             component: EmployeeSalaryWrapperComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { employeeSalary: ['add'] }, mode: SalaryMode.CREATE }
//           },
//           {
//             path: `${eps.hrm.base}/${eps.hrm.reviseSalary}/:id`,
//             component: EmployeeSalaryWrapperComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { employeeSalary: ['edit'] }, mode: SalaryMode.REVISE }
//           },
//           {
//             path: `${eps.hrm.base}/${eps.hrm.updateSalary}/:id`,
//             component: EmployeeSalaryWrapperComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { employeeSalary: ['edit'] }, mode: SalaryMode.UPDATE }
//           },

//           {
//             path: `${eps.hrm.base}/${eps.hrm.createPayout}/:id`,
//             component: PayoutAgreementWrapperComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { employeeSalary: ['add'] }, mode: PayOutMode.CREATE }
//           },
//           {
//             path: `${eps.hrm.base}/${eps.hrm.revisePayout}/:id`,
//             component: PayoutAgreementWrapperComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { employeeSalary: ['edit'] }, mode: PayOutMode.REVISE }
//           },
//           {
//             path: `${eps.hrm.base}/${eps.hrm.updatePayout}/:id`,
//             component: PayoutAgreementWrapperComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { employeeSalary: ['edit'] }, mode: PayOutMode.UPDATE }
//           },

//           {
//             path: `${eps.hrm.base}/${eps.hrm.managePayroll}`,
//             component: ManagePayrollComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { payroll: ['view'] } }
//           },
//           {
//             path: `${eps.hrm.base}/${eps.hrm.runPayroll}`,
//             component: RunPayrollComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { payroll: ['add', 'edit', 'delete'] } }
//           },
//           { path: `${eps.hrm.base}/${eps.hrm.payslip}`, component: PayslipWrapperComponent },
//           {
//             path: `${eps.hrm.base}/${eps.hrm.payrollSummary}/:id`,
//             component: PayrollSummaryComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { payroll: ['view'] } }
//           },
//           {
//             path: `${eps.hrm.base}/${eps.hrm.investments}`,
//             component: InvestmentsWrapperComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { payroll: ['view'] } }
//           },
//           {
//             path: `${eps.hrm.base}/${eps.hrm.manageContractorPayroll}`,
//             component: ManageContractorPayrollComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { payroll: ['view'] } }
//           },
//           {
//             path: `${eps.hrm.base}/${eps.hrm.runContractorPayroll}`,
//             component: RunContractorPayrollComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { payroll: ['view'] } }
//           },
//           {
//             path: `${eps.hrm.base}/${eps.hrm.contractorPayrollSummary}/:id`,
//             component: ContractorPayrollSummaryComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { payroll: ['view'] } }
//           },
//           { path: `${eps.hrm.base}/${eps.hrm.invoice}`, component: InvoiceWrapperComponent },

//           // USER ROLE & PERMISSIONS
//           {
//             path: `${eps.userRole.base}/${eps.userRole.role}`,
//             component: RolePermissionComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { userRole: ['view'] } }
//           },
//           {
//             path: `${eps.userRole.base}/${eps.userRole.permissionSet}`,
//             component: PermissionSetsComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { userRole: ['view'] } }
//           },
//           {
//             path: `${eps.userRole.base}/${eps.userRole.permissionsetdetails}/:id`,
//             component: PermissionSetDetailsComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { userRole: ['view'] } }
//           },

//           // ROLE
//           {
//             path: `${eps.role.base}/${eps.role.role}`,
//             component: RoleComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { role: ['view'] } }
//           },
//           {
//             path: `${eps.role.base}/${eps.role.roledetails}/:id`,
//             component: RoleDetailComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { role: ['view'] } }
//           },

//           // PERMISSION SET
//           {
//             path: `${eps.permissionSet.base}/${eps.permissionSet.permissionSet}`,
//             component: PermissionSetComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { permissionSet: ['view'] } }
//           },
//           {
//             path: `${eps.permissionSet.base}/${eps.permissionSet.permissionSetdetails}/:id`,
//             component: PermissionSetDetailComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { permissionSet: ['view'] } }
//           },

//           // ATTENDANCE
//           {
//             path: `${eps.attendance.base}/${eps.attendance.policies}`,
//             component: AttendancePolicyComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { attendancePolicy: ['view'] } }
//           },
//           {
//             path: `${eps.attendance.base}/${eps.attendance.attendanceList}`,
//             component: AttendanceListComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: [{ adminAttendance: ['view'] }, { attendance: ['view'] }] }
//           },
//           {
//             path: 'attendance',
//             children: [
//               {
//                 path: 'attendance-policy-details/:policyId',
//                 component: AttendancePolicyDetailsComponent
//               }
//             ]
//           },
//           {
//             path: `${eps.attendance.base}/${eps.attendance.employeeAttendance}/:id`,
//             component: AttendanceComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: [{ attendance: ['view'] }, { attendanceAdmin: ['view'] }] }
//           },
//           {
//             path: `${eps.attendance.base}/${eps.attendance.calander}`,
//             component: CalanderComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: [{ attendance: ['view'] }, { business: ['view'] }] }
//           },

//           // LEAVES
//           {
//             path: `${eps.leaves.base}/${eps.leaves.holidays}`,
//             component: HolidaysComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { holidays: ['view'] } }
//           },
//           {
//             path: `${eps.leaves.base}/${eps.leaves.policies}`,
//             component: LeavePoliciesComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { leavePolicy: ['view'] } }
//           },
//           {
//             path: `${eps.leaves.base}/${eps.leaves.appliedLeave}`,
//             component: AppliedLeavesComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { leaves: ['view'] } }
//           },
//           {
//             path: `${eps.leaves.base}/${eps.leaves.leavesRequest}`,
//             component: LeavesRequestComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { leaveRequests: ['view'] } }
//           },
//           {
//             path: `${eps.leaves.base}/${eps.leaves.assignedPolicyDetail}/:id`,
//             component: LeavePolicyDetailComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { leavePolicy: ['view'] } }
//           },
//           {
//             path: `${eps.leaves.base}/${eps.leaves.assignedPolicyBalance}`,
//             component: LeaveBalanceComponent
//           },

//           // PLAN & BILLING
//           {
//             path: `${eps.planAndBilling.base}/${eps.planAndBilling.plan}`,
//             component: BasicComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { plansAndBilling: ['view'] } }
//           },
//           {
//             path: `${eps.planAndBilling.base}/${eps.planAndBilling.upgradePlan}`,
//             component: PlanSelectionComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { plansAndBilling: ['view'] } }
//           },
//           {
//             path: `${eps.planAndBilling.base}/${eps.planAndBilling.changePlanSummary}/:id`,
//             component: PlanChangeSummaryComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { plansAndBilling: ['view'] } }
//           },
//           {
//             path: `${eps.planAndBilling.base}/${eps.planAndBilling.paymentCallback}`,
//             component: PaymentCallbackComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { plansAndBilling: ['view'] } }
//           },
//           {
//             path: `${eps.planAndBilling.base}/${eps.planAndBilling.paymentSuccess}`,
//             component: PaymentSuccessComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { plansAndBilling: ['view'] } }
//           },
//           {
//             path: `${eps.planAndBilling.base}/${eps.planAndBilling.paymentFailure}`,
//             component: PaymentFailureComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { plansAndBilling: ['view'] } }
//           },
//           {
//             path: `${eps.planAndBilling.base}/${eps.planAndBilling.activatePlan}/:id`,
//             component: ActivatePlanComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { plansAndBilling: ['view'] } }
//           },
//           {
//             path: `${eps.planAndBilling.base}/${eps.planAndBilling.previewAddLicences}/:id`,
//             component: AddLicencePreviewComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: { plansAndBilling: ['view'] } }
//           },
//           {
//             path: `${eps.notifications.notifications}/:userId`,
//             component: NotificationComponent,
//             canActivate: [permissionGuard]
//             // data: { permissions: { notifications: ['view'] } }
//           },
//           {
//             path: `${eps.employeeManager.base}/${eps.employeeManager.teamMembers}/:id`,
//             component: TeamMembersComponent,
//             canActivate: [permissionGuard]
//             // data: { permissions: { employeeManager: ['view'] } }
//           },

//           // event
//           {
//             path: `${eps.event.base}/${eps.event.birthdays}`,
//             component: BirthdaysComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: [{ event: ['view'] }, { employees: ['view'] }] }
//           },
//           {
//             path: `${eps.event.base}/${eps.event.anniversary}`,
//             component: AnniversaryComponent,
//             canActivate: [permissionGuard],
//             data: { permissions: [{ event: ['view'] }, { employees: ['view'] }] }
//           }
//         ]
//       }
//     ]
//   },

//   // MAIN APP layout (header/sidebar render ONCE)
//   // {
//   //   path: '',
//   //   component: AppTemplateComponent,
//   //   canActivate: [authGuard],
//   //   children: [
//   //     // USER module routes (kept as same final URLs as before)
//   //     {
//   //       path: `${eps.user.base}/${eps.user.dashboard}`,
//   //       component: DashboardComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { dashboard: ['view', 'edit'] } }
//   //     },
//   //     { path: `${eps.user.base}/${eps.user.unauthorized}`, component: UnauthorizedComponent },
//   //     {
//   //       path: `${eps.user.base}/${eps.user.employeeDashboard}`,
//   //       component: EmpDashboardComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { dashboard: ['view', 'edit'] } }
//   //     },
//   //     {
//   //       path: `${eps.user.base}/${eps.user.ownerDashboard}`,
//   //       component: OwnerDashboardComponent
//   //       // canActivate: [permissionGuard],
//   //       // data: { permissions: { dashboard: ['view', 'edit'] } }
//   //     },
//   //     {
//   //       path: `${eps.user.base}/${eps.user.employeeRequest}`,
//   //       component: EmployeeRequestComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: [{ user: ['view'] }, { employees: ['view'] }] }
//   //     },
//   //     {
//   //       path: `${eps.user.base}/${eps.user.orgChart}`,
//   //       component: OrgChartComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: [{ user: ['view'] }, { employees: ['view'] }] }
//   //     },

//   //     // COMPANY module
//   //     {
//   //       path: `${eps.company.base}/${eps.company.business}`,
//   //       component: BusinessComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { business: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.company.base}/${eps.company.business}/:id`,
//   //       component: BusinessDetailComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { business: ['view'] } }
//   //     },
//   //     { path: `${eps.company.base}/${eps.company.salaryComponents}`, component: WrapperComponent },
//   //     {
//   //       path: `${eps.company.base}/${eps.company.office}/:id`,
//   //       component: OfficeDetailsComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { office: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.company.base}/${eps.company.department}`,
//   //       component: DepartmentComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { department: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.company.base}/${eps.company.designation}`,
//   //       component: DesignationComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { designation: ['view'] } }
//   //     },
//   //     { path: `${eps.company.base}/${eps.company.taxSettings}`, component: TaxWrapperComponent },

//   //     // SUPER ADMIN
//   //     {
//   //       path: `${eps.superAdmin.base}/${eps.superAdmin.plans}`,
//   //       component: PlansComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { plans: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.superAdmin.base}/${eps.superAdmin.subscribers}`,
//   //       component: SubscribersComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { plans: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.superAdmin.base}/${eps.superAdmin.licenceHistory}/:id`,
//   //       component: LicenceHistoryComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { plans: ['view'] } }
//   //     },

//   //     // HRM
//   //     {
//   //       path: `${eps.hrm.base}/${eps.hrm.employee}`,
//   //       component: EmployeeComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: [{ user: ['view'], employees: ['view'] }] }
//   //     },
//   //     {
//   //       path: `${eps.hrm.base}/${eps.hrm.employee}/:id`,
//   //       component: EmployeeDetailComponent,
//   //       canActivate: [permissionGuard],
//   //       // data: { permissions: { user: ['view'], employees: ['view'] } }
//   //       data: { permissions: [{ user: ['view'] }, { employees: ['view'] }] }
//   //     },

//   //     {
//   //       path: `${eps.hrm.base}/${eps.hrm.createSalary}/:id`,
//   //       component: EmployeeSalaryWrapperComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { employeeSalary: ['add'] }, mode: SalaryMode.CREATE }
//   //     },
//   //     {
//   //       path: `${eps.hrm.base}/${eps.hrm.reviseSalary}/:id`,
//   //       component: EmployeeSalaryWrapperComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { employeeSalary: ['edit'] }, mode: SalaryMode.REVISE }
//   //     },
//   //     {
//   //       path: `${eps.hrm.base}/${eps.hrm.updateSalary}/:id`,
//   //       component: EmployeeSalaryWrapperComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { employeeSalary: ['edit'] }, mode: SalaryMode.UPDATE }
//   //     },

//   //     {
//   //       path: `${eps.hrm.base}/${eps.hrm.createPayout}/:id`,
//   //       component: PayoutAgreementWrapperComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { employeeSalary: ['add'] }, mode: PayOutMode.CREATE }
//   //     },
//   //     {
//   //       path: `${eps.hrm.base}/${eps.hrm.revisePayout}/:id`,
//   //       component: PayoutAgreementWrapperComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { employeeSalary: ['edit'] }, mode: PayOutMode.REVISE }
//   //     },
//   //     {
//   //       path: `${eps.hrm.base}/${eps.hrm.updatePayout}/:id`,
//   //       component: PayoutAgreementWrapperComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { employeeSalary: ['edit'] }, mode: PayOutMode.UPDATE }
//   //     },

//   //     {
//   //       path: `${eps.hrm.base}/${eps.hrm.managePayroll}`,
//   //       component: ManagePayrollComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { payroll: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.hrm.base}/${eps.hrm.runPayroll}`,
//   //       component: RunPayrollComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { payroll: ['add', 'edit', 'delete'] } }
//   //     },
//   //     { path: `${eps.hrm.base}/${eps.hrm.payslip}`, component: PayslipWrapperComponent },
//   //     {
//   //       path: `${eps.hrm.base}/${eps.hrm.payrollSummary}/:id`,
//   //       component: PayrollSummaryComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { payroll: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.hrm.base}/${eps.hrm.investments}`,
//   //       component: InvestmentsWrapperComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { payroll: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.hrm.base}/${eps.hrm.manageContractorPayroll}`,
//   //       component: ManageContractorPayrollComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { payroll: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.hrm.base}/${eps.hrm.runContractorPayroll}`,
//   //       component: RunContractorPayrollComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { payroll: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.hrm.base}/${eps.hrm.contractorPayrollSummary}/:id`,
//   //       component: ContractorPayrollSummaryComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { payroll: ['view'] } }
//   //     },
//   //     { path: `${eps.hrm.base}/${eps.hrm.invoice}`, component: InvoiceWrapperComponent },

//   //     // USER ROLE & PERMISSIONS
//   //     {
//   //       path: `${eps.userRole.base}/${eps.userRole.role}`,
//   //       component: RolePermissionComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { userRole: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.userRole.base}/${eps.userRole.permissionSet}`,
//   //       component: PermissionSetsComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { userRole: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.userRole.base}/${eps.userRole.permissionsetdetails}/:id`,
//   //       component: PermissionSetDetailsComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { userRole: ['view'] } }
//   //     },

//   //     // ROLE
//   //     {
//   //       path: `${eps.role.base}/${eps.role.role}`,
//   //       component: RoleComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { role: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.role.base}/${eps.role.roledetails}/:id`,
//   //       component: RoleDetailComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { role: ['view'] } }
//   //     },

//   //     // PERMISSION SET
//   //     {
//   //       path: `${eps.permissionSet.base}/${eps.permissionSet.permissionSet}`,
//   //       component: PermissionSetComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { permissionSet: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.permissionSet.base}/${eps.permissionSet.permissionSetdetails}/:id`,
//   //       component: PermissionSetDetailComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { permissionSet: ['view'] } }
//   //     },

//   //     // ATTENDANCE
//   //     {
//   //       path: `${eps.attendance.base}/${eps.attendance.policies}`,
//   //       component: AttendancePolicyComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { attendancePolicy: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.attendance.base}/${eps.attendance.attendanceList}`,
//   //       component: AttendanceListComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: [{ adminAttendance: ['view'] }, { attendance: ['view'] }] }
//   //     },
//   //     {
//   //       path: 'attendance',
//   //       children: [
//   //         {
//   //           path: 'attendance-policy-details/:policyId',
//   //           component: AttendancePolicyDetailsComponent
//   //         }
//   //       ]
//   //     },
//   //     {
//   //       path: `${eps.attendance.base}/${eps.attendance.employeeAttendance}/:id`,
//   //       component: AttendanceComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: [{ attendance: ['view'] }, { attendanceAdmin: ['view'] }] }
//   //     },
//   //     {
//   //       path: `${eps.attendance.base}/${eps.attendance.calander}`,
//   //       component: CalanderComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: [{ attendance: ['view'] }, { business: ['view'] }] }
//   //     },

//   //     // LEAVES
//   //     {
//   //       path: `${eps.leaves.base}/${eps.leaves.holidays}`,
//   //       component: HolidaysComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { holidays: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.leaves.base}/${eps.leaves.policies}`,
//   //       component: LeavePoliciesComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { leavePolicy: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.leaves.base}/${eps.leaves.appliedLeave}`,
//   //       component: AppliedLeavesComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { leaves: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.leaves.base}/${eps.leaves.leavesRequest}`,
//   //       component: LeavesRequestComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { leaveRequests: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.leaves.base}/${eps.leaves.assignedPolicyDetail}/:id`,
//   //       component: LeavePolicyDetailComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { leavePolicy: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.leaves.base}/${eps.leaves.assignedPolicyBalance}`,
//   //       component: LeaveBalanceComponent
//   //     },

//   //     // PLAN & BILLING
//   //     {
//   //       path: `${eps.planAndBilling.base}/${eps.planAndBilling.plan}`,
//   //       component: BasicComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { plansAndBilling: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.planAndBilling.base}/${eps.planAndBilling.upgradePlan}`,
//   //       component: PlanSelectionComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { plansAndBilling: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.planAndBilling.base}/${eps.planAndBilling.changePlanSummary}/:id`,
//   //       component: PlanChangeSummaryComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { plansAndBilling: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.planAndBilling.base}/${eps.planAndBilling.paymentCallback}`,
//   //       component: PaymentCallbackComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { plansAndBilling: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.planAndBilling.base}/${eps.planAndBilling.paymentSuccess}`,
//   //       component: PaymentSuccessComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { plansAndBilling: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.planAndBilling.base}/${eps.planAndBilling.paymentFailure}`,
//   //       component: PaymentFailureComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { plansAndBilling: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.planAndBilling.base}/${eps.planAndBilling.activatePlan}/:id`,
//   //       component: ActivatePlanComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { plansAndBilling: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.planAndBilling.base}/${eps.planAndBilling.previewAddLicences}/:id`,
//   //       component: AddLicencePreviewComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: { plansAndBilling: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.notifications.notifications}/:userId`,
//   //       component: NotificationComponent,
//   //       canActivate: [permissionGuard]
//   //       // data: { permissions: { notifications: ['view'] } }
//   //     },
//   //     {
//   //       path: `${eps.employeeManager.base}/${eps.employeeManager.teamMembers}/:id`,
//   //       component: TeamMembersComponent,
//   //       canActivate: [permissionGuard]
//   //       // data: { permissions: { employeeManager: ['view'] } }
//   //     },

//   //     // event
//   //     {
//   //       path: `${eps.event.base}/${eps.event.birthdays}`,
//   //       component: BirthdaysComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: [{ event: ['view'] }, { employees: ['view'] }] }
//   //     },
//   //     {
//   //       path: `${eps.event.base}/${eps.event.anniversary}`,
//   //       component: AnniversaryComponent,
//   //       canActivate: [permissionGuard],
//   //       data: { permissions: [{ event: ['view'] }, { employees: ['view'] }] }
//   //     }
//   //   ]
//   // },

//   // default route inside app -> redirect to dashboard (adjust if necessary)
//   //   { path: '', redirectTo: `${eps.user.base}/${eps.user.dashboard}`, pathMatch: 'full' }
//   // ]

//   // Wildcard redirect to auth (or 404 component if you prefer)
//   { path: '**', redirectTo: eps.auth.base, pathMatch: 'full' }
// ]

//25 june 2026

export const websiteRoutes: Routes = [
  {
    path: '',
    component: WebsiteLayoutComponent,
    children: [
      { path: '', component: HomeComponent },
      { path: 'privacy-policy', component: PrivacyPolicyComponent },
      { path: 'refund-policy', component: RefundPolicyComponent },
      { path: 'terms-and-conditions', component: TermsConditionComponent }
    ]
  }
]

export const ownerDashboardGuard: CanActivateFn = () => {
  const utilsService = inject(UtilsService)
  const router = inject(Router)

  return utilsService.isBusinessOwner()
    ? true
    : router.createUrlTree([eps.user.base, eps.user.unauthorized])
}

export const hrmsRoutes: Routes = [
  {
    path: '',
    component: HrmsLayoutComponent,
    children: [
      {
        path: eps.auth.base,
        component: AuthTemplateComponent,
        canActivate: [GuestGuard],
        children: [
          { path: eps.auth.login, component: LoginComponent },
          { path: `${eps.auth.register}/:id`, component: RegistrationComponent },
          { path: `${eps.auth.chooseSubscription}/:id`, component: ChooseSubscriptionComponent },
          { path: eps.auth.forgotPassword, component: ForgotPasswordComponent },
          { path: eps.auth.resetPassword, component: ResetPasswordComponent },
          // default of auth base -> login
          { path: '', redirectTo: eps.auth.login, pathMatch: 'full' }
        ]
      },
      {
        path: '',
        component: AppTemplateComponent,
        canActivate: [authGuard],
        // canActivateChild: [authGuard],
        children: [
          // USER module routes (kept as same final URLs as before)
          {
            path: `${eps.user.base}/${eps.user.dashboard}`,
            component: DashboardComponent,
            canActivate: [permissionGuard],
            data: { permissions: { dashboard: ['view', 'edit'] } }
          },
          { path: `${eps.user.base}/${eps.user.unauthorized}`, component: UnauthorizedComponent },
          {
            path: `${eps.user.base}/${eps.user.employeeDashboard}`,
            component: EmpDashboardComponent,
            canActivate: [permissionGuard],
            data: { permissions: { dashboard: ['view', 'edit'] } }
          },
          {
            path: `${eps.user.base}/${eps.user.ownerDashboard}`,
            component: OwnerDashboardComponent,
            // canActivate: [permissionGuard],
            canActivate: [permissionGuard],
            data: { permissions: { ownerDashboard: ['view'] } }
          },
          {
            path: `${eps.user.base}/${eps.user.employeeRequest}`,
            component: EmployeeRequestComponent,
            canActivate: [permissionGuard],
            data: { permissions: [{ user: ['view'] }, { employees: ['view'] }] }
          },
          {
            path: `${eps.user.base}/${eps.user.orgChart}`,
            component: OrgChartComponent,
            canActivate: [permissionGuard],
            data: { permissions: [{ orgChart: ['view'] }] }
          },

          // COMPANY module
          {
            path: `${eps.company.base}/${eps.company.business}`,
            component: BusinessComponent,
            canActivate: [permissionGuard],
            data: { permissions: { business: ['view'] } }
          },
          {
            path: `${eps.company.base}/${eps.company.business}/:id`,
            component: BusinessDetailComponent,
            canActivate: [permissionGuard],
            data: { permissions: { business: ['view'] } }
          },
          {
            path: `${eps.company.base}/${eps.company.salaryComponents}`,
            component: WrapperComponent,
            canActivate: [permissionGuard]
          },
          {
            path: `${eps.company.base}/${eps.company.office}/:id`,
            component: OfficeDetailsComponent,
            canActivate: [permissionGuard],
            data: { permissions: { office: ['view'] } }
          },
          {
            path: `${eps.company.base}/${eps.company.department}`,
            component: DepartmentComponent,
            canActivate: [permissionGuard],
            data: { permissions: { department: ['view'] } }
          },
          {
            path: `${eps.company.base}/${eps.company.designation}`,
            component: DesignationComponent,
            canActivate: [permissionGuard],
            data: { permissions: { designation: ['view'] } }
          },
          {
            path: `${eps.company.base}/${eps.company.taxSettings}`,
            component: TaxWrapperComponent
          },

          // SUPER ADMIN
          {
            path: `${eps.superAdmin.base}/${eps.superAdmin.plans}`,
            component: PlansComponent,
            canActivate: [permissionGuard],
            data: { permissions: { plans: ['view'] } }
          },
          {
            path: `${eps.superAdmin.base}/${eps.superAdmin.subscribers}`,
            component: SubscribersComponent,
            canActivate: [permissionGuard],
            data: { permissions: { subscribers: ['view'] } }
          },
          {
            path: `${eps.superAdmin.base}/${eps.superAdmin.licenceHistory}/:id`,
            component: LicenceHistoryComponent,
            canActivate: [permissionGuard],
            data: { permissions: { subscribers: ['view'] } }
          },
          {
            path: `${eps.superAdmin.base}/${eps.superAdmin.cron}`,
            component: CronComponent
            // canActivate: [permissionGuard],
            // data: { permissions: { subscribers: ['view'] } }
          },
          {
            path: `${eps.cron.base}/${eps.cron.admin}/history/:id`,
            component: CronDetailComponent
            // canActivate: [permissionGuard],
            // data: { permissions: { subscribers: ['view'] } }
          },

          {
            path: `${eps.notificationCampaign.base}`,
            component: NotificationCampaignComponent
            // canActivate: [permissionGuard],
            // data: { permissions: { subscribers: ['view'] } }
          },
          {
            path: `${eps.notificationCampaign.base}/${eps.notificationCampaign.templates}`,
            component: NotificationOccasionTemplateComponent
            // canActivate: [permissionGuard],
            // data: { permissions: { subscribers: ['view'] } }
          },
          {
            path: `${eps.notificationCampaign.base}/:id`,
            component: NotificationCampaignDetailComponent
            // canActivate: [permissionGuard],
            // data: { permissions: { subscribers: ['view'] } }
          },

          // HRM
          {
            path: `${eps.hrm.base}/${eps.hrm.employee}`,
            component: EmployeeComponent,
            canActivate: [permissionGuard],
            data: { permissions: [{ user: ['view'], employees: ['view'] }] }
          },
          {
            path: `${eps.hrm.base}/${eps.hrm.employee}/:id`,
            component: EmployeeDetailComponent,
            canActivate: [permissionGuard],
            // data: { permissions: { user: ['view'], employees: ['view'] } }
            data: { permissions: [{ user: ['view'] }, { employees: ['view'] }] }
          },

          {
            path: `${eps.hrm.base}/${eps.hrm.createSalary}/:id`,
            component: EmployeeSalaryWrapperComponent,
            canActivate: [permissionGuard],
            data: { permissions: { employeeSalary: ['add'] }, mode: SalaryMode.CREATE }
          },
          {
            path: `${eps.hrm.base}/${eps.hrm.reviseSalary}/:id`,
            component: EmployeeSalaryWrapperComponent,
            canActivate: [permissionGuard],
            data: { permissions: { employeeSalary: ['edit'] }, mode: SalaryMode.REVISE }
          },
          {
            path: `${eps.hrm.base}/${eps.hrm.updateSalary}/:id`,
            component: EmployeeSalaryWrapperComponent,
            canActivate: [permissionGuard],
            data: { permissions: { employeeSalary: ['edit'] }, mode: SalaryMode.UPDATE }
          },

          {
            path: `${eps.hrm.base}/${eps.hrm.createPayout}/:id`,
            component: PayoutAgreementWrapperComponent,
            canActivate: [permissionGuard],
            data: { permissions: { employeeSalary: ['add'] }, mode: PayOutMode.CREATE }
          },
          {
            path: `${eps.hrm.base}/${eps.hrm.revisePayout}/:id`,
            component: PayoutAgreementWrapperComponent,
            canActivate: [permissionGuard],
            data: { permissions: { employeeSalary: ['edit'] }, mode: PayOutMode.REVISE }
          },
          {
            path: `${eps.hrm.base}/${eps.hrm.updatePayout}/:id`,
            component: PayoutAgreementWrapperComponent,
            canActivate: [permissionGuard],
            data: { permissions: { employeeSalary: ['edit'] }, mode: PayOutMode.UPDATE }
          },

          {
            path: `${eps.hrm.base}/${eps.hrm.managePayroll}`,
            component: ManagePayrollComponent,
            canActivate: [permissionGuard],
            data: { permissions: { payroll: ['view'] } }
          },
          {
            path: `${eps.hrm.base}/${eps.hrm.runPayroll}`,
            component: RunPayrollComponent,
            canActivate: [permissionGuard],
            data: { permissions: { payroll: ['add', 'edit', 'delete'] } }
          },
          {
            path: `${eps.hrm.base}/${eps.hrm.payslip}`,
            component: PayslipWrapperComponent,
            canActivate: [permissionGuard],
            data: { permissions: [{ payslip: ['view'] }, { user: ['view'] }] }
          },
          {
            path: `${eps.hrm.base}/${eps.hrm.payrollSummary}/:id`,
            component: PayrollSummaryComponent,
            canActivate: [permissionGuard],
            data: { permissions: { payroll: ['view'] } }
          },
          {
            path: `${eps.hrm.base}/${eps.hrm.investments}`,
            component: InvestmentsWrapperComponent,
            canActivate: [permissionGuard],
            data: { permissions: { payroll: ['view'] } }
          },
          {
            path: `${eps.hrm.base}/${eps.hrm.manageContractorPayroll}`,
            component: ManageContractorPayrollComponent,
            canActivate: [permissionGuard],
            data: { permissions: { payroll: ['view'] } }
          },
          {
            path: `${eps.hrm.base}/${eps.hrm.runContractorPayroll}`,
            component: RunContractorPayrollComponent,
            canActivate: [permissionGuard],
            data: { permissions: { payroll: ['view'] } }
          },
          {
            path: `${eps.hrm.base}/${eps.hrm.contractorPayrollSummary}/:id`,
            component: ContractorPayrollSummaryComponent,
            canActivate: [permissionGuard],
            data: { permissions: { payroll: ['view'] } }
          },
          {
            path: `${eps.hrm.base}/${eps.hrm.invoice}`,
            component: InvoiceWrapperComponent,
            canActivate: [permissionGuard],
            data: { permissions: [{ contractor: ['view'] }, { user: ['view'] }] }
          },

          // USER ROLE & PERMISSIONS
          {
            path: `${eps.userRole.base}/${eps.userRole.role}`,
            component: RolePermissionComponent,
            canActivate: [permissionGuard],
            data: { permissions: { userRole: ['view'] } }
          },
          {
            path: `${eps.userRole.base}/${eps.userRole.permissionSet}`,
            component: PermissionSetsComponent,
            canActivate: [permissionGuard],
            data: { permissions: { userRole: ['view'] } }
          },
          {
            path: `${eps.userRole.base}/${eps.userRole.permissionsetdetails}/:id`,
            component: PermissionSetDetailsComponent,
            canActivate: [permissionGuard],
            data: { permissions: { userRole: ['view'] } }
          },

          // ROLE
          {
            path: `${eps.role.base}/${eps.role.role}`,
            component: RoleComponent,
            canActivate: [permissionGuard],
            data: { permissions: { role: ['view'] } }
          },
          {
            path: `${eps.role.base}/${eps.role.roledetails}/:id`,
            component: RoleDetailComponent,
            canActivate: [permissionGuard],
            data: { permissions: { role: ['view'] } }
          },

          // PERMISSION SET
          {
            path: `${eps.permissionSet.base}/${eps.permissionSet.permissionSet}`,
            component: PermissionSetComponent,
            canActivate: [permissionGuard],
            data: { permissions: { permissionSet: ['view'] } }
          },
          {
            path: `${eps.permissionSet.base}/${eps.permissionSet.permissionSetdetails}/:id`,
            component: PermissionSetDetailComponent,
            canActivate: [permissionGuard],
            data: { permissions: { permissionSet: ['view'] } }
          },

          // ATTENDANCE
          {
            path: `${eps.attendance.base}/${eps.attendance.policies}`,
            component: AttendancePolicyComponent,
            canActivate: [permissionGuard],
            data: { permissions: { attendancePolicy: ['view'] } }
          },
          {
            path: `${eps.attendance.base}/${eps.attendance.attendanceList}`,
            component: AttendanceListComponent,
            canActivate: [permissionGuard],
            data: { permissions: [{ attendanceAdmin: ['view'] }, { attendance: ['view'] }] }
          },
          {
            path: 'attendance',
            children: [
              {
                path: 'attendance-policy-details/:policyId',
                component: AttendancePolicyDetailsComponent
              }
            ]
          },
          {
            path: `${eps.attendance.base}/${eps.attendance.employeeAttendance}/:id`,
            component: AttendanceComponent,
            canActivate: [permissionGuard],
            data: { permissions: [{ attendance: ['view'] }, { attendanceAdmin: ['view'] }] }
          },
          {
            path: `${eps.attendance.base}/${eps.attendance.calander}`,
            component: CalanderComponent,
            canActivate: [permissionGuard],
            data: { permissions: [{ attendance: ['view'] }, { business: ['view'] }] }
          },

          // LEAVES
          {
            path: `${eps.leaves.base}/${eps.leaves.holidays}`,
            component: HolidaysComponent,
            canActivate: [permissionGuard],
            data: { permissions: { holidays: ['view'] } }
          },
          {
            path: `${eps.leaves.base}/${eps.leaves.policies}`,
            component: LeavePoliciesComponent,
            canActivate: [permissionGuard],
            data: { permissions: { leavePolicy: ['view'] } }
          },
          {
            path: `${eps.leaves.base}/${eps.leaves.appliedLeave}`,
            component: AppliedLeavesComponent,
            canActivate: [permissionGuard],
            data: { permissions: { leaves: ['view'] } }
          },
          {
            path: `${eps.leaves.base}/${eps.leaves.leavesRequest}`,
            component: LeavesRequestComponent,
            canActivate: [permissionGuard],
            data: { permissions: { leaveRequests: ['view'] } }
          },
          {
            path: `${eps.leaves.base}/${eps.leaves.assignedPolicyDetail}/:id`,
            component: LeavePolicyDetailComponent,
            canActivate: [permissionGuard],
            data: { permissions: { leavePolicy: ['view'] } }
          },
          {
            path: `${eps.leaves.base}/${eps.leaves.assignedPolicyBalance}`,
            component: LeaveBalanceComponent,
            canActivate: [permissionGuard],
            data: { permissions: { leaveBalance: ['view'] } }
          },

          // PLAN & BILLING
          {
            path: `${eps.planAndBilling.base}/${eps.planAndBilling.plan}`,
            component: BasicComponent,
            canActivate: [permissionGuard, ownerDashboardGuard],
            data: { permissions: { plansAndBilling: ['view'] } }
          },
          {
            path: `${eps.planAndBilling.base}/${eps.planAndBilling.upgradePlan}`,
            component: PlanSelectionComponent,
            canActivate: [permissionGuard],
            data: { permissions: { plansAndBilling: ['view'] } }
          },
          {
            path: `${eps.planAndBilling.base}/${eps.planAndBilling.renewPlan}/:id`,
            component: ActivatePlanComponent,
            canActivate: [permissionGuard],
            data: { permissions: { plansAndBilling: ['view'] } }
          },
          {
            path: `${eps.planAndBilling.base}/${eps.planAndBilling.changePlanSummary}/:id`,
            component: PlanChangeSummaryComponent,
            canActivate: [permissionGuard],
            data: { permissions: { plansAndBilling: ['view'] } }
          },
          {
            path: `${eps.planAndBilling.base}/${eps.planAndBilling.paymentCallback}`,
            component: PaymentCallbackComponent,
            canActivate: [permissionGuard],
            data: { permissions: { plansAndBilling: ['view'] } }
          },
          {
            path: `${eps.planAndBilling.base}/${eps.planAndBilling.paymentSuccess}`,
            component: PaymentSuccessComponent,
            canActivate: [permissionGuard],
            data: { permissions: { plansAndBilling: ['view'] } }
          },
          {
            path: `${eps.planAndBilling.base}/${eps.planAndBilling.paymentFailure}`,
            component: PaymentFailureComponent,
            canActivate: [permissionGuard],
            data: { permissions: { plansAndBilling: ['view'] } }
          },
          {
            path: `${eps.planAndBilling.base}/${eps.planAndBilling.activatePlan}/:id`,
            component: ActivatePlanComponent,
            canActivate: [permissionGuard],
            data: { permissions: { plansAndBilling: ['view'] } }
          },
          {
            path: `${eps.planAndBilling.base}/${eps.planAndBilling.previewAddLicences}/:id`,
            component: AddLicencePreviewComponent,
            canActivate: [permissionGuard],
            data: { permissions: { plansAndBilling: ['view'] } }
          },
          {
            path: `${eps.planAndBilling.base}/${eps.planAndBilling.billing}`,
            component: BillingComponent,
            canActivate: [permissionGuard],
            data: { permissions: { plansAndBilling: ['view'] } }
          },
          {
            path: `${eps.notifications.notifications}/:userId`,
            component: NotificationComponent,
            canActivate: [permissionGuard]
            // data: { permissions: { notifications: ['view'] } }
          },
          {
            path: `${eps.employeeManager.base}/${eps.employeeManager.teamMembers}/:id`,
            component: TeamMembersComponent,
            canActivate: [permissionGuard]
            // data: { permissions: { employeeManager: ['view'] } }
          },

          // event
          {
            path: `${eps.event.base}/${eps.event.birthdays}`,
            component: BirthdaysComponent,
            canActivate: [permissionGuard],
            data: { permissions: [{ event: ['view'] }, { employees: ['view'] }] }
          },
          {
            path: `${eps.event.base}/${eps.event.anniversary}`,
            component: AnniversaryComponent,
            canActivate: [permissionGuard],
            data: { permissions: [{ event: ['view'] }, { employees: ['view'] }] }
          },
          {
            path: `${eps.superAdmin.base}/${eps.superAdmin.coupons}`,
            component: CouponComponent
            // canActivate: [permissionGuard],
            // data: { permissions: [{ coupons: ['view'] }] }
          },
          {
            path: `earnings`,
            component: EarningsComponent
            // canActivate: [permissionGuard],
            // data: { permissions: [{ coupons: ['view'] }] }
          },
          {
            path: `userLoginHistory`,
            component: UserLoginHistoryComponent
            // canActivate: [permissionGuard],
            // data: { permissions: [{ coupons: ['view'] }] }
          }
        ]
      }
    ]
  }
  // Wildcard redirect to auth (or 404 component if you prefer)
  //   { path: '**', redirectTo: eps.auth.base, pathMatch: 'full' }
]
// const host = window.location.hostname
// const port = window.location.port
// // const isHrms = environment.hrmsHosts.includes(host) || port === '4300'
// const isHrms =
//   host === 'localhost' ||
//   host === 'app.avrhrms.com' ||
//   host.endsWith('-app.avrhrms.com') ||
//   port === '4300' ||
//   port === '4206' ||
//   port === '4208' ||
//   port === '4210'

// // export const isHrms = environment.appType === 'hrms'

// export const routes: Routes = isHrms ? hrmsRoutes : websiteRoutes
// export const routes: Routes = host === 'app.avrhrms.com' ? hrmsRoutes : websiteRoutes

// export const hrmsMatchGuard: CanMatchFn = () => isHrmsHost()
// export const websiteMatchGuard: CanMatchFn = () => !isHrmsHost()

export const hrmsMatchGuard: CanMatchFn = () => {
  const result = isHrmsHost()
  // console.log('hrmsMatchGuard:', result)
  return result
}

export const websiteMatchGuard: CanMatchFn = () => {
  const result = !isHrmsHost()
  // console.log('websiteMatchGuard:', result)
  return result
}

export const routes: Routes = [
  {
    path: '',
    canMatch: [hrmsMatchGuard],
    children: hrmsRoutes
  },
  {
    path: '',
    canMatch: [websiteMatchGuard],
    children: websiteRoutes
  }
]
